import React,{useEffect,useRef}from "react";
import {Box,Typography}from "@mui/material";
import "./working.css";
import connectWallet from "../../../../static/Images/working/connect_wallet.png";
import selectGame from "../../../../static/Images/working/select_game.png";
import placeBet from "../../../../static/Images/working/place_bet.png";
import result from "../../../../static/Images/working/result.png";
import withdraw from "../../../../static/Images/working/withdraw.png";
import {setupWorkingAnimations}from "../animations/workAnimation";
import colors from "../../../../theme/colors";
import typography from "../../../../theme/typography";

const steps=[
  {
    number:"01",
    title:"Connect Wallet",
    description:"Connect your crypto wallet securely to AutoBET and get access to the platform. Your wallet is used to manage bets and winnings.",
    image:connectWallet
  },
  {
    number:"02",
    title:"Choose a Game",
    description:"Explore the available games and choose the one you want to play. Each game offers a simple and transparent betting experience.",
    image:selectGame
  },
  {
    number:"03",
    title:"Place Your Bet",
    description:"Select your preferred bet amount and make your choice. Review the details and confirm your bet to enter the game.",
    image:placeBet
  },
  {
    number:"04",
    title:"Results on-Chain",
    description:"Once the game is completed, the result is recorded on-chain. This makes the outcome transparent, verifiable, and easy to trust.",
    image:result
  },
  {
    number:"05",
    title:"Win & Withdraw",
    description:"If you win, your rewards become available to withdraw. Transfer your winnings securely back to your connected wallet.",
    image:withdraw
  }
];

const Working=()=>{
  const sectionRef=useRef(null);
  const visualRef=useRef(null);
  const eyebrowRef=useRef(null);
  const panelRefs=useRef([]);

  useEffect(()=>{
    return setupWorkingAnimations({
      sectionRef,
      visualRef,
      eyebrowRef,
      panelRefs,
      steps
    });
  },[]);

  return(
    <Box
      ref={sectionRef}
      component="section"
      className="working-section"
      sx={{
        '--working-bg-dark': colors.home.navyDeep,
        '--working-bg-light': colors.neutral.white,
        '--working-text-muted': colors.home.textMuted,
        '--working-text-light': colors.home.textLight,
        '--working-slate': colors.slate[500],
        '--working-size-eyebrow': typography.workingSection.eyebrow,
        '--working-size-heading': typography.workingSection.heading,
        '--working-size-heading-md': typography.workingSection.headingMd,
        '--working-size-heading-sm': typography.workingSection.headingSm,
        '--working-size-title': typography.workingSection.title,
        '--working-size-title-sm': typography.workingSection.titleSm,
        '--working-size-desc': typography.workingSection.description,
        '--working-size-desc-sm': typography.workingSection.descriptionSm,
        '--working-size-number': typography.workingSection.number,
      }}
    >
      <Box className="working-container">

        <Box
          ref={visualRef}
          className="working-visual"
        >
          {steps.map((step,index)=>(
            <Box
              key={step.number}
              ref={element=>{
                panelRefs.current[index]=element;
              }}
              className="working-panel"
            >
              <img
                src={step.image}
                alt={step.title}
                className="working-image"
              />
            </Box>
          ))}
        </Box>

        <Box className="working-content">

          <Typography
            ref={eyebrowRef}
            className="working-eyebrow"
          >
            HOW IT WORKS
          </Typography>

          <Typography className="working-heading">
            Simple. Secure. Transparent.
          </Typography>

          {steps.map((step,index)=>(
            <Box
              key={step.number}
              className={`working-step working-step-${index}`}
            >
              <Typography className="working-number">
                {step.number}
              </Typography>

              <Typography className="working-title">
                {step.title}
              </Typography>

              <Typography className="working-description">
                {step.description}
              </Typography>
            </Box>
          ))}

        </Box>
      </Box>
    </Box>
  );
};

export default Working;